import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://dvpdigi.world";
const DEFAULT_TITLE =
  "DVP DIGI WORLD — Personal, Home, Business & Mortgage Loans in Chennai";
const DEFAULT_DESC =
  "Get the right loan from India's leading banks. DVP DIGI WORLD offers Personal, Home, Business, Mortgage (LAP), Doctor & Professional loans, Insurance, Mutual Funds & SIPs in Chennai. ₹150 Cr+ disbursed.";

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [tag, attrName] = selector.replace("meta[", "").replace("]", "").split("=");
    const [a, v] = attrName ? attrName.split('"').filter(Boolean) : [];
    if (tag) el.setAttribute(a || "name", v || tag);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setOrCreateMeta = (key, name, content) => {
  let el = document.head.querySelector(`meta[${key}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

const removeJsonLdById = (id) => {
  const el = document.getElementById(id);
  if (el) el.remove();
};

const injectJsonLd = (id, data) => {
  removeJsonLdById(id);
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
};

export const useSEO = ({
  title,
  description,
  path,
  jsonLd,
  ogImage,
  noindex = false,
} = {}) => {
  const location = useLocation();
  const finalPath = path || location.pathname;
  const finalTitle = title ? `${title} | DVP DIGI WORLD` : DEFAULT_TITLE;
  const finalDesc = description || DEFAULT_DESC;
  const url = `${SITE_URL}${finalPath}`;

  useEffect(() => {
    document.title = finalTitle;
    setOrCreateMeta("name", "description", finalDesc);
    setOrCreateMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    setOrCreateMeta("property", "og:title", finalTitle);
    setOrCreateMeta("property", "og:description", finalDesc);
    setOrCreateMeta("property", "og:url", url);
    setOrCreateMeta("name", "twitter:title", finalTitle);
    setOrCreateMeta("name", "twitter:description", finalDesc);
    setOrCreateMeta("name", "twitter:url", url);
    if (ogImage) {
      setOrCreateMeta("property", "og:image", ogImage);
      setOrCreateMeta("name", "twitter:image", ogImage);
    }
    setCanonical(url);

    if (jsonLd) {
      injectJsonLd("page-jsonld", jsonLd);
    } else {
      removeJsonLdById("page-jsonld");
    }
  }, [finalTitle, finalDesc, url, jsonLd, noindex, ogImage]);
};

export default useSEO;
